import { SET_ONLINE_POINTS } from '../constants/index';
import makeReducer from '../../utils/fabrickReducer';

const initialState = {
    onlinePoints: [],
};

export default makeReducer(initialState, SET_ONLINE_POINTS);